import { Controller } from "@hotwired/stimulus"

// Two live readouts on the dashboard secondary nav: a UTC clock and a countdown
// to the next auto-refresh. This controller only DISPLAYS — the `auto-refresh`
// controller (on the page content) triggers the actual reload. Both reconnect
// together when Turbo replaces the body on refresh, so the countdown resets in
// step with the real reload without a shared timer. Keep the interval in sync
// with the page's data-auto-refresh-interval-value.
export default class extends Controller {
  static targets = ["clock", "countdown"]
  static values = { interval: { type: Number, default: 60000 } }

  connect() {
    this.deadline = Date.now() + this.intervalValue
    this.tick()
    this.timer = setInterval(() => this.tick(), 250)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    if (this.hasClockTarget) {
      // toISOString() is always UTC: "2026-07-23T14:05:09.123Z" -> "14:05:09"
      this.clockTarget.textContent = new Date().toISOString().slice(11, 19)
    }
    if (this.hasCountdownTarget) {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000))
      this.countdownTarget.textContent = `${remaining}s`
    }
  }
}
